import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet } from "lucide-react";
import { generateExport } from "@/utils/exportUtils";

export function ExportDropdown({ data, filename, title }: { data: Record<string, unknown>[], filename: string, title?: string }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-7 text-[10px] gap-1 px-2 border-border/80 hover:bg-muted/40">
          <FileSpreadsheet className="w-3 h-3 text-muted-foreground" /> Exporter
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36 z-50">
        <DropdownMenuItem onClick={() => generateExport(data, filename, title, 'excel')} className="text-xs cursor-pointer">Excel (.xlsx)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => generateExport(data, filename, title, 'word')} className="text-xs cursor-pointer">Word (.doc)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => generateExport(data, filename, title, 'pdf')} className="text-xs cursor-pointer">PDF (.pdf)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
